module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@2x-e3d55747a5d04620fa59db872129644c.png";